import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
export default {
  React,
  Router
};